<template>
  <div>
    <br>
    <h1 class="title has-text-centered has-text-weight-medium">Checking payment status</h1>
    <h2 class="subtitle has-text-centered">Please do not go back or refresh.</h2>
    <div v-if="paymentStatus === paymentStatusCodes[0]" class="has-text-centered has-text-grey">
      <p class="is-size-6">This page will expire in 3 minutes</p>
      <p class="is-size-5">
        <span class="icon is-medium">
          <font-awesome-icon icon="stopwatch" />
        </span>
        {{ timer.min }} : {{ timer.sec }}
      </p>
    </div>
    <div class="spinner" v-if="paymentStatus === paymentStatusCodes[0]"></div>
    <div class="checkmark draw" v-if="paymentStatus === paymentStatusCodes[1]"></div>
    <div class="cross" v-if="paymentStatus === paymentStatusCodes[2]"></div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import Constants from '@/util/constants'
import Util from '@/util'

export default {
  name: 'OrderStatus',
  data () {
    return {
      timeLimit: 180000,
      intervalFn: null,
      timeoutFn: null,
      counterFn: null,
      paymentStatusCodes: Constants.dataMap.paymentStatus,
      expiry: null,
      timer: {}
    }
  },
  mounted () {
    const interval = 5000
    const getSale = () => {
      this.$store.dispatch('cart/getSale', {
        callback: () => {
          this.checkPaymentStatus();
        }
      })
    }
    this.expiry = new Date().setMilliseconds(this.timeLimit)

    this.intervalFn = setInterval(() => {
      getSale()
    }, interval)

    getSale()

    this.timeoutFn = setTimeout(() => {
      getSale()
      clearInterval(this.intervalFn)
      clearInterval(this.counterFn)
      this.displayOrderResult()
    }, this.timeLimit)
    this.counterFn = setInterval(() => {
      this.updateCountDown()
    }, 1000)
  },
  computed: {
    ...mapState('cart', ['saleError', 'paymentTxn']),
    paymentStatus () {
      if (Util.isEmpty(this.paymentTxn)) {
        return ''
      }
      return this.paymentTxn.paymentStatus
    }
  },
  methods: {
    updateCountDown () {
      let timeLeft = this.expiry - new Date().getTime()
      this.timer = {
        min: this.getZeroPad(Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60))),
        sec: this.getZeroPad(Math.floor((timeLeft % (1000 * 60)) / 1000))
      }
    },
    clearTimers () {
      clearInterval(this.intervalFn)
      clearTimeout(this.timeoutFn)
      clearInterval(this.counterFn)
    },
    displayOrderResult () {
      this.$router.push({ name: 'OutletOrderResult' })
    },
    getZeroPad (n) {
      return (parseInt(n, 10) >= 10 ? '' : '0') + n;
    },
    checkPaymentStatus (paymentStatus) {
      if (paymentStatus !== this.paymentStatusCodes[0] || this.saleError) {
        this.clearTimers()
        setTimeout(() => {
          this.displayOrderResult()
        }, 2000)
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    if (from.name && from.name.includes('OrderStatus') && !to.name.includes('OrderResult')) {
      this.clearTimers()
      return next({ name: 'OutletOrderResult' })
    }
    next()
  }
}
</script>
<style lang="scss" scoped>
@keyframes spinner {
    0% {
      transform: translate3d(-50%, -50%, 0) rotate(0deg);
    }
    100% {
      transform: translate3d(-50%, -50%, 0) rotate(360deg);
    }
}
.spinner {
    // The height here is just for demo purposes
    height: 70vh;
    opacity: 1;
    position: relative;
    transition: opacity linear 0.1s;
    &::before {
        animation: 2s linear infinite spinner;
        border: solid 10px #eee;
        border-bottom-color: #EF6565;
        border-radius: 50%;
        content: "";
        height: 40vh;
        left: 50%;
        opacity: inherit;
        position: absolute;
        top: 50%;
        transform: translate3d(-50%, -50%, 0);
        transform-origin: center;
        width: 40vh;
        will-change: transform;
    }
}

// Define vars we'll be using
$loader-size: 20em;
$check-height: $loader-size/2;
$check-width: $check-height/2;
$check-thickness: 10px;
$check-color:  #5cb85c;
$tablet: 768px;

.checkmark {
  height: 70vh;
  &.draw:after {
    top: 50%;
    left: 45vw;
    @media screen and (max-width: $tablet) {
      left: 30vw;
    }
    animation-duration: 800ms;
    animation-timing-function: ease;
    animation-name: checkmark;
    transform: scaleX(-1) rotate(135deg);
  }
  &:after {
    opacity: 1;
    height: $check-height;
    width: $check-width;
    transform-origin: left top;
    border-right: $check-thickness solid $check-color;
    border-top: $check-thickness solid $check-color;
    content: '';
    position: absolute;
  }
}

@keyframes checkmark {
  0% {
    height: 0;
    width: 0;
    opacity: 1;
  }
  20% {
    height: 0;
    width: $check-width;
    opacity: 1;
  }
  40% {
    height: $check-height;
    width: $check-width;
    opacity: 1;
  }
  100% {
    height: $check-height;
    width: $check-width;
    opacity: 1;
  }
}

.cross {
  position: absolute;
  left: 50vw;
  top: 30%;
  width: 20em;
  height: 20em;
}
.cross:before, .cross:after {
  position: absolute;
  content: ' ';
  height: 20em;
  width: 10px;
  background-color: #EF6565;
}
.cross:before {
  transform: rotate(45deg);
}
.cross:after {
  transform: rotate(-45deg);
}
</style>
